import React from "react";
import { Drawer, Row, Col } from "antd";
import TextArea from "antd/lib/input/TextArea";
import Keyboard from "react-simple-keyboard";

const NotesDrawer = ({
  visible,
  open,
  onClose,
  onSave,
  notesValue,
  exchangeNotesValue,
  setExchangeNotesValue,
  activeCartTable,
  setActiveCartTable,
  onChangeInputKeyboard,
  handleKeyDown,
  notesInputRef,
  selectedProductForNotes,
  closeIcon,
  keyboardRef,
  layoutName,
  setLayoutName,
  onChange,
  handleShift,
}) => {
  return (
    <Drawer
      placement="bottom"
      height="60vh"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "2vh",
            fontSize: "1vw",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              marginTop: "3vh",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            {selectedProductForNotes !== null ? "Add Notes for Item" : "Add Notes for Order"}
          </p>
          <img
            src={closeIcon}
            onClick={onClose}
            style={{
              marginLeft: "auto",
              marginTop: "4vh",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      closeIcon={null}
      className="filter"
      styles={{ body: { paddingTop: 0 } }}
      open={visible || open}
      closable={false}
      headerStyle={{ background: "#F3F4F9", borderBottom: "none" }}
      styles={{ body: { padding: "20px", color: "#2F3856", background: "#F3F4F9" } }}
      onClose={onClose}
      
      footer={null}
    >
      <Row style={{ padding: "0 5vw", fontSize: "1vw" }}>
        <Col span={11}>
          <TextArea
            id="notes-input"
            ref={notesInputRef}
            style={{ resize: "none" }}
            maxLength={200}
            onKeyDown={handleKeyDown}
            onChange={(e) => onChangeInputKeyboard(e)}
            value={activeCartTable === "EXCHANGE" ? exchangeNotesValue : notesValue}
            rows={11}
          />
          <span
            style={{
              fontFamily: "Inter",
              fontSize: "0.8em",
              color: "#929098",
              fontWeight: 500,
            }}
          >
            Max Characters : 200
          </span>
        </Col>
        <Col span={12} offset={1}>
          <Keyboard
            theme={"hg-theme-default aprvl"}
            onChange={(input) => onChange(input)}
            keyboardRef={(r) => (keyboardRef.current = r)}
            onKeyPress={(button) => {
              if (button === "{shift}" || button === "{lock}") handleShift();
              if (button === "{number}") {
                setLayoutName("number");
              }
              if (button === "{numbers}") {
                setLayoutName("numbers");
              }
              if (button === "{small}") {
                setLayoutName("shift");
              }
              if (button === "{caps}") {
                setLayoutName("default");
              }
              if (button === "{enter}") {
                onSave();
              }
            }}
            layoutName={layoutName}
            display={{
              "{abc}": "ABC",
              "{smileys}": "\uD83D\uDE03",
              "{back}": "Enter",
              "{numbers}": "123",
              "{number}": "123",
              "{bksp}": "backspace",
              "{backspace}": "\u232B",
              "{shift}": "\u21E7",
              "{tab}": "tab",
              "{lock}": "lock",
              "{enter}": "Enter",
              "{space}": "Space",
              "{caps}": "ABC",
              "{small}": "abc",
            }}
            layout={{
              shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
              numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
              number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
              default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
            }}
          />
        </Col>
      </Row>
    </Drawer>
  );
};

export default NotesDrawer;
